export default __webpack_public_path__ + "static/media/app-store-logo.0cf56337.svg";